import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import apiService from '../../services/api.service';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../Redux/userReducer';
import CompanyHeader from './CompanyHeader';
import CompanyLoginModal from './CompanyLoginModal';
import { Fragment } from 'react';
import CompanyVerificationModal from './CompanyVerificationModal';
import { setCompany, setCompanyUser } from '../../Redux/companyReducer';
import { useTranslation } from '../../hooks/useTranslation';

function Company() {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const companyUser = useSelector((state) => state.company.companyUser)
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const chainId = urlParams.get("chainid") || 0;
    const lang = urlParams.get("lang") || "en";
    const company = useSelector((state) => state.company.company)
    const [waitingForCode, setWaitingForCode] = useState(false)
    const [currentUser, setCurrentUser] = useState(null)
    const [isCompanyChain, setIsCompanyChain] = useState(false);
    const handleShow = () => setShowModal(true);
    const handleClose = () => {
        setShowModal(false)
        setWaitingForCode(false)
        resetCompany()
    }
    const resetCompany = () => {
        dispatch(setCompany(null))
        dispatch(setCompanyUser(null))
    }

    useEffect(() => {
        apiService.getCompany().then(response => {
            if (response.data && !response.data.errors && response.data.data) {
                const companies = response.data.data;

                companies.forEach(company => {
                    if ((company.chains) && (company.chains.length) && (company.chains.findIndex(c => c.chainId == chainId) !== -1)) {
                        setIsCompanyChain(true);
                    }
                });
            }
        })
    }, []);

    const checkVerificationCode = (data, setError) => {
        const code = data.code
        setIsLoading(true)
        apiService.confirmCode(currentUser.iD, code)
            .then((response) => {
                if (response.data.data && !response.data.HasErrors) {
                    apiService.getCompany(currentUser.companyId)
                        .then((response) => {
                            if (response.data.data && response.data.data.length) {
                                dispatch(setCompany(response.data.data[0]));

                                const companyUser = {
                                    customerFirstName: currentUser.firstName,
                                    customerLastName: currentUser.lastName,
                                    customerPhone: currentUser.phoneNumber,
                                    customerEmail: currentUser.email,
                                    companyId: currentUser.companyId
                                }
                                dispatch(setCompanyUser(companyUser))

                                const loggedUser = {
                                    id: currentUser.iD,
                                    email: currentUser.email,
                                    chainId: chainId
                                }
                                dispatch(setUser(loggedUser));
                            } else {
                                alert("Company not found");
                                return;
                            }
                        })
                    setShowModal(false)
                    setWaitingForCode(false)
                    setIsLoading(false)

                } else {
                    setError('code', { message: t("FailedVerification") });
                    setIsLoading(false)
                }
            }, (error) => {
                console.log(error)
                setIsLoading(false)
                setError('code', { message: t("FailedVerification") });
            })
    }

    const handleLogin = async (data = currentUser, setError = null) => {
        setIsLoading(true);

        try {
            const user = { Email: data.email, chainId: chainId }
            const response = await apiService.login(user);

            if (!response.data?.data || response.data?.errors) {    // no user
                setError?.("email", { type: "custom", message: t("CustomerNotFound") });
                return;
            }

            const companyId = response.data.data.user?.companyId;

            if (!companyId || !chainId) {   // no company connect to user
                setError?.("email", { type: "custom", message: t("CustomerNotFound") });
                return;
            }

            const resCompany = await apiService.getCompany(companyId, chainId);

            if (!resCompany.data?.data?.length) {   // no company in chain
                setError?.("email", { type: "custom", message: t("CompanyNotFound") });
                return;
            }

            setCurrentUser({
                ...response.data.data.user,
                email: data.email
            });

            setWaitingForCode(true);
        } catch {
            setError?.("email", { type: "custom", message: t("CustomerNotFound") });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        isCompanyChain &&
        <div className={`company-login ${companyUser ? "company-user" : ""}`}>
            {!company && !companyUser && !waitingForCode &&
                <Fragment>
                    <Button className="company-login-btn" aria-label={t("LoginForCompaniesAndOrganizations")} variant="light" onClick={handleShow}>{t("LoginForCompaniesAndOrganizations")}</Button>
                    <CompanyLoginModal
                        showModal={showModal}
                        isLoading={isLoading}
                        handleLogin={handleLogin}
                        handleClose={handleClose}
                    />
                </Fragment>
            }
            {companyUser && !waitingForCode &&
                <CompanyHeader
                    lang={lang}
                    chainId={chainId}
                    company={company}
                    urlParams={urlParams}
                    isLoading={isLoading}
                    companyUser={companyUser}
                    setIsLoading={setIsLoading}
                />
            }
            {waitingForCode && currentUser &&
                <Fragment>
                    <Button className="company-login-btn" aria-label={t("loginForCompaniesAndOrganizations")} variant="light" onClick={handleShow}>{t("LoginForCompaniesAndOrganizations")}</Button>
                    <CompanyVerificationModal
                        showModal={showModal}
                        isLoading={isLoading}
                        handleLogin={handleLogin}
                        currentUser={currentUser}
                        handleClose={handleClose}
                        checkVerificationCode={checkVerificationCode}
                    />
                </Fragment>
            }
        </div>
    );
}

export default Company;
